import { WorkBook } from "xlsx-js-style";
import { ExcelData, ExcelOptions, ExcelTemplate } from "../../interfaces";
import { getPreparedData } from "./mapping";
import * as XLSX from 'xlsx-js-style';
import { fitToColumn } from "../financial-statement/utils";
import { PortfolioPerformance } from "src/app/domain/pp/dto/PortfolioPerformance";
import { setColumnWidth, withHeaderStyling } from "../../utils";

export class SharedDetailsTemplate implements ExcelTemplate {
  export(data: PortfolioPerformance[], options: ExcelOptions): WorkBook {
    const book = XLSX.utils.book_new();
    const sheet = this.getSheet(data);
    XLSX.utils.book_append_sheet(book, sheet);
    return book;
  }

  private getSheet(exportExcelData: PortfolioPerformance[]): XLSX.WorkSheet {
    const headersForDisplay = this.getHeadersForDisplay();
    const headersForLogic = this.getHeadersForLogic();
    const preparedData = getPreparedData(exportExcelData, headersForDisplay , headersForLogic);
    const longColumnIndexes = [2, 6];
    const sheet = {
      ...XLSX.utils.aoa_to_sheet(preparedData),
      '!cols': fitToColumn(preparedData),
    };
    longColumnIndexes.forEach((index) => setColumnWidth(sheet, index, 1));
    return withHeaderStyling(sheet);
  }

  private getHeadersForDisplay() {
    return ['Company', 'Valuated PPS', '', 'Owned', 'Fully diluted', 'Holding', '', 'Owned', 'Fully diluted', 'Holding' ];
  }

  private getHeadersForLogic() {
    return ['Company', 'Valuated PPS', 'space(0)', 'Owned(0)', 'Fully diluted(0)', 'Holding(0)', 'space(1)', 'Owned(1)', 'Fully diluted(1)', 'Holding(1)' ];
  }
}
